import React, { useContext, useState } from 'react'
import './index.scss'
import { ICONS, ILLUSTRATIONS } from '@Const/common'
import Button from '@Components/Buttons/Button'
import Navigation from '@App/navigation'
import { StoresContext } from '@App/contexts'
import { useNavigate } from 'react-router'

interface WelcomePopupProps {
    onClose(): void
}

const WelcomePopup = (props: WelcomePopupProps) => {
    const [numStep, setNumStep] = useState(1)
    const { userStore, authStore } = useContext(StoresContext)
    const navigate = useNavigate()

    const finishShowingWelcomePopup = async () => {
        props.onClose()
        userStore.changeUserSetting('showWelcomePopup', false)
    }

    const goToPortal = async () => {
        navigate(Navigation.home.root())
        await finishShowingWelcomePopup()
    }

    const startRegistration = async () => {
        if (authStore.isLoggedIn) {
            navigate(Navigation.registrationRightsholder.form())
        } else {
            navigate(Navigation.signUp.root())
        }
        await finishShowingWelcomePopup()
    }

    return (
        <div className="main-block">
            <img
                onClick={finishShowingWelcomePopup}
                className={`close ${numStep === 2 ? 'white' : ''}`}
                src={ICONS.close}
                alt="close"
            />
            <div className="welcome-popup">
                {numStep === 1 && (
                    <div className="intro-step">
                        <div>
                            <h3>Welcome to The MLC Portal!</h3>
                            <p>
                                Please note that you need access to a Member account to take any action in the Portal.
                            </p>
                        </div>

                        <img src={ILLUSTRATIONS.illustration4} alt="illustration" />
                    </div>
                )}
                {numStep === 2 && (
                    <div className="second-step">
                        <div>
                            <h3>View the Portal</h3>
                            <p>
                                If you were invited to an existing Member account to help manage the account, you can go
                                straight to the Portal. Click the button below to get started.Please note that the
                                features you see in the Portal depend on which user type you are.
                            </p>
                            <Button mainColor type="primary" onClick={goToPortal}>
                                View the Portal
                            </Button>
                        </div>
                        <div>
                            <h3>Or create a Member</h3>
                            <p>
                                If you are responsible for collecting digital audio mechanical royalties, you will need
                                to setup a Member to collect those royalties. At The MLC, a "Member" is the entity
                                through which you collect royalties - think of it as a business or company!
                            </p>
                            <Button mainColor={false} type="primary" onClick={startRegistration}>
                                Create a Member
                            </Button>
                        </div>
                    </div>
                )}
                <div className="footer-block">
                    <div className="steps">
                        <div
                            className="active"
                            onClick={() => {
                                setNumStep(1)
                            }}
                        />
                        <div
                            className={`${numStep === 2 ? 'active' : ''}`}
                            onClick={() => {
                                setNumStep(2)
                            }}
                        />
                    </div>
                    {numStep === 1 && (
                        <Button
                            mainColor
                            type="primary"
                            icon={ICONS.arrow_forward}
                            onClick={() => {
                                setNumStep(2)
                            }}
                        >
                            Next
                        </Button>
                    )}
                </div>
            </div>
        </div>
    )
}

export default WelcomePopup
